export const timeoutsEndStorageKey = 'startTrialPeriodPopupTimeoutsEnd';
